import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { ContextMenuItem } from "lib/@components/context-menu-bar/context-menu-item"
import { confirm } from "lib/@dialogs/confirm"
import { deleteDraft } from "routes/schedule/edit/delete-button"

export function RemoveDraft() {
    const { target } = useBoundContext()
    return <ContextMenuItem icon="material-symbols:delete" label="Delete" onClick={remove} />

    async function remove() {
        if (await confirm("Are you sure?", "Delete Draft")) {
            await deleteDraft(target._id)
        }
    }
}
